/**
 * @generated SignedSource<<ac8874ca32b38b5e09e4c49e7b7a7a78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CommonQuery_getConfigVersionQuery$variables = {};
export type CommonQuery_getConfigVersionQuery$data = {
  readonly getConfigVersion: ReadonlyArray<{
    readonly fileName: string;
    readonly url: string;
  }>;
};
export type CommonQuery_getConfigVersionQuery = {
  response: CommonQuery_getConfigVersionQuery$data;
  variables: CommonQuery_getConfigVersionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GetFilesOutputObjectType",
    "kind": "LinkedField",
    "name": "getConfigVersion",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommonQuery_getConfigVersionQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CommonQuery_getConfigVersionQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "feb7c18a65cb888325a606941a365410",
    "id": null,
    "metadata": {},
    "name": "CommonQuery_getConfigVersionQuery",
    "operationKind": "query",
    "text": "query CommonQuery_getConfigVersionQuery {\n  getConfigVersion {\n    fileName\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc090fffbc5113feb3864745f7d22d4d";

export default node;
